import React from 'react'

interface BadgeProps {
  variant?: 'default' | 'secondary' | 'success' | 'warning' | 'danger' | 'info' | 'brand' | 'purple' | 'pink' | 'indigo'
  size?: 'sm' | 'md'
  className?: string
  title?: string
  children: React.ReactNode
}

const Badge: React.FC<BadgeProps> = ({ 
  variant = 'default', 
  size = 'sm',
  className = '', 
  title,
  children 
}) => {
  const baseClasses = 'inline-flex items-center rounded-full font-medium'
  
  const variantClasses = {
    default: 'bg-secondary-100 text-secondary-700 ring-1 ring-inset ring-secondary-200',
    secondary: 'bg-secondary-50 text-secondary-600 ring-1 ring-inset ring-secondary-200',
    success: 'bg-success-50 text-success-700 ring-1 ring-inset ring-success-200',
    warning: 'bg-warning-50 text-warning-700 ring-1 ring-inset ring-warning-200',
    danger: 'bg-danger-50 text-danger-700 ring-1 ring-inset ring-danger-200',
    info: 'bg-info-50 text-info-700 ring-1 ring-inset ring-info-200',
    brand: 'bg-brand-50 text-brand-700 ring-1 ring-inset ring-brand-200',
    purple: 'bg-purple-100 text-purple-800 ring-1 ring-inset ring-purple-600/20',
    pink: 'bg-pink-100 text-pink-800 ring-1 ring-inset ring-pink-600/20',
    indigo: 'bg-indigo-100 text-indigo-800 ring-1 ring-inset ring-indigo-600/20',
  }
  
  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm',
  }
  
  return (
    <span 
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
      title={title}
    >
      {children}
    </span>
  )
}

export default Badge